/**
 * Hex color utilities. No browser/server dependencies.
 * All blending is done in RGB space so vivid colors naturally desaturate
 * when lightened (like mixing paint with white) instead of going neon.
 */
function hexToRgb(hex) {
    return [
        parseInt(hex.slice(1, 3), 16),
        parseInt(hex.slice(3, 5), 16),
        parseInt(hex.slice(5, 7), 16),
    ];
}
function rgbToHex(r, g, b) {
    const clamp = (v) => Math.round(Math.min(255, Math.max(0, v)));
    return `#${clamp(r).toString(16).padStart(2, "0")}${clamp(g).toString(16).padStart(2, "0")}${clamp(b).toString(16).padStart(2, "0")}`.toUpperCase();
}
/**
 * Lighten a hex color by `amount` (0-1).
 * Blends toward white in RGB space, naturally desaturating vivid colors.
 */
export function lighten(hex, amount) {
    const [r, g, b] = hexToRgb(hex);
    return rgbToHex(r + (255 - r) * amount, g + (255 - g) * amount, b + (255 - b) * amount);
}
/**
 * Darken a hex color by `amount` (0-1).
 * Blends toward black in RGB space (e.g. 0.8 = 80% darker).
 */
export function darken(hex, amount) {
    const [r, g, b] = hexToRgb(hex);
    return rgbToHex(r * (1 - amount), g * (1 - amount), b * (1 - amount));
}
